module.exports = __webpack_public_path__ + "img/mlt_x_ultra_compact.a7d5e715.jpg";